export default {
  COOKIE_KEY: 'qontak._token.hub',
}
